import React from 'react';
import '../css/components/success.css'

interface SuccessProps {
    children?: React.ReactNode;
}

function Success(props: SuccessProps) {
    return (
        <div className="ss-success">{props.children}</div>
    );
}

export default Success;
